import { isNotEmptyValue } from "kwikid-toolkit";
import {
  TKwikUIStarRatingSize,
  VKwikUIStarRatingSize
} from "./star-rating.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";
  const isNumber = (x: number) => typeof x === "number";

  const methods = {
    color: isString,
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    icon: isString && isNotEmptyValue,
    iconMarked: isString && isNotEmptyValue,
    id: isString,
    invalid: isBoolean,
    label: isString,
    max: isNumber,
    min: isNumber,
    placeholder: isString,
    size: (x: TKwikUIStarRatingSize) => VKwikUIStarRatingSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
